import { leerSesion } from "../api.ts";

/** Recuerda a administración y dirección que deben activar la verificación en dos pasos (los días que quedan); desaparece al activarla. */
export function AvisoDosPasos({ ir }: { ir: (ruta: string) => void }) {
  const dp = leerSesion()?.usuario.dosPasos;
  if (!dp || !dp.obligatorio || dp.activo) return null;
  const dias = dp.diasRestantes ?? 0;
  return (
    <section className="card" aria-labelledby="t-dos-pasos">
      <div className="fila" style={{ justifyContent: "space-between", alignItems: "baseline", flexWrap: "wrap", gap: 8 }}>
        <h2 id="t-dos-pasos" style={{ margin: 0 }}>Activa la verificación en dos pasos</h2>
        <span className="chip rojo">{dias > 0 ? `Te quedan ${dias} día${dias === 1 ? "" : "s"}` : "Plazo vencido"}</span>
      </div>
      <p className="muted" style={{ margin: 0, fontSize: 13 }}>
        Tu cuenta ve toda la información de la clínica. Además de tu contraseña, Donna pedirá un número de 6 dígitos de tu celular: así, aunque alguien se entere de tu contraseña, no puede entrar. Toma dos minutos.
      </p>
      <div><button className="btn pri" onClick={() => ir("configuracion")}>Activarla ahora</button></div>
    </section>
  );
}
